<template>
  <div>
    <a-card title="客户资金列表" class="card">
      <a-row gutter="16">
        <a-col :span="24" style="max-width: 200px; margin-bottom: 12px">
          <a-input v-model="searchForm.search" placeholder="迅投账户" allowClear @pressEnter="search" />
        </a-col>

        <a-col :span="24" style="width: 100px; margin-bottom: 12px">
          <a-button type="primary" icon="search" @click="search">查询</a-button>
        </a-col>
      </a-row>

      <a-row style="margin-top: 12px">
        <a-table size="small" :columns="columns" :dataSource="items" rowKey="id" :loading="loading"
          :pagination="pagination" @change="tableChange">
        </a-table>
      </a-row>
    </a-card>
    <form-modal v-model="visible" :form="targetItem" :clientsClassificationOptions="clientsClassificationItems"
      @create="create" @update="update" />
    <a-modal v-model="importLoading" :footer="null" :maskClosable="false" :closable="false">
      <div><a-spin style="margin-right: 12px" />正在导入中, 请等待...</div>
    </a-modal>
  </div>
</template>

<script>
import { exportExcel } from "@/utils/excel";
import { clientExport } from "@/api/export";
import { clientTemplate, clientImport } from "@/api/import";
import { assetList, clientDestroy } from "@/api/custom";
import { getClientNumber } from "@/api/data";

export default {
  name: "Client",
  components: {
    FormModal: () => import("./FormModal.vue"),
  },
  data () {
    return {
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          width: 60,
          customRender: (value, item, index) => {
            return index + 1;
          },
        },
        {
          title: "交易日期",
          dataIndex: "trade_dt",
        },
        {
          title: "迅投账户",
          dataIndex: "p_user_name",
          sorter: true,
        },
        {
          title: "券商账户",
          dataIndex: "q_user_name",
          sorter: true,
        },
        {
          title: "总资产",
          dataIndex: "m_dbalance",
        },
        {
          title: "净资产",
          dataIndex: "m_dassureasset",
        },
        {
          title: "总市值",
          dataIndex: "m_dstockvalue",
        },
        {
          title: "总负债",
          dataIndex: "m_dtotaldebit",
        },
        {
          title: "可用金额",
          dataIndex: "m_davailable",
        },
        {
          title: "盈亏",
          dataIndex: "m_dpositionprofit",
        },
      ],
      searchForm: { search: "", page: 1, page_size: 12 },
      pagination: { current: 1, total: 0, pageSize: 12 },
      loading: false,
      items: [],
      clientsClassificationItems: [],
      visible: false,
      targetItem: {},
      form: { is_active: true },
      importLoading: false,
    };
  },
  computed: {},
  methods: {
    initialize () {
      this.list();
    },
    list () {
      this.loading = true;
      assetList(this.searchForm)
        .then((data) => {
          if (data.code==0){
          this.pagination.total = data.total;
          this.items = data.results;}else{
            this.$message.error(data.msg);
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    create (item) {
      // this.items.splice(0, 0, item);
      this.list();
    },
    update (item) {
      this.items.splice(
        this.items.findIndex((i) => i.id == item.id),
        1,
        item
      );
    },
    search () {
      this.searchForm.page = 1;
      this.pagination.current = 1;
      this.list();
    },
    openFormModal (item) {
      if (!item.id) {
        getClientNumber().then((data) => {
          this.targetItem = { ...item, ...{ number: data.number } };
        });
      } else {
        this.targetItem = { ...item };
      }

      this.visible = true;
    },
    destroy (id) {
      clientDestroy({ id }).then(() => {
        // this.items.splice(
        //   this.items.findIndex((item) => item.id == id),
        //   1
        // );
        this.$message.success("删除成功");
        this.list();
      });
    },
    exportExcel () {
      clientExport(this.searchForm)
        .then((resp) => {
          exportExcel(resp.data, "客户列表");
          this.$message.success("导出成功");
        })
        .catch((err) => {
          this.$message.error(err.response.data.error);
        });
    },
    downloadTemplate () {
      clientTemplate()
        .then((resp) => {
          exportExcel(resp.data, "客户导入模板");
          this.$message.success("模板导出成功");
          this.list();
        })
        .catch((err) => {
          this.$message.error(err.response.data.error);
        });
    },
    importExcel (item) {
      let data = new FormData();
      data.append("file", item.file);
      this.importLoading = true;
      setTimeout(() => {
        clientImport(data)
          .then(() => {
            this.$message.success("导入成功");
            this.list();
          })
          .catch((err) => {
            alert("导入错误:" + "\n" + err.response.data.join("\n"));
          })
          .finally(() => {
            this.importLoading = false;
          });
      }, 1000);
    },
    tableChange (pagination, filters, sorter) {
      this.searchForm.page = pagination.current;
      this.pagination.current = pagination.current;
      this.searchForm.ordering = `${sorter.order == "descend" ? "-" : ""}${sorter.field}`;
      this.list();
    },
  },
  mounted () {
    this.initialize();
  },
};
</script>
<style scoped>
.card {
  border-radius: 8px;
}
</style>
